import { render, staticRenderFns } from "./ownership.vue?vue&type=template&id=2a34624a&scoped=true&"
import script from "./ownership.vue?vue&type=script&lang=js&"
export * from "./ownership.vue?vue&type=script&lang=js&"
import style0 from "./ownership.vue?vue&type=style&index=0&id=2a34624a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a34624a",
  null
  
)

export default component.exports